/** 파일 종류 이름 — 첨부 목록의 "Word document · 47 KB" 표기 */
const KIND_BY_EXT = {
  pdf: 'PDF',
  png: 'Image',
  jpg: 'Image',
  jpeg: 'Image',
  gif: 'Image',
  webp: 'Image',
  doc: 'Word document',
  docx: 'Word document',
  xls: 'Spreadsheet',
  xlsx: 'Spreadsheet',
  ppt: 'Slides',
  pptx: 'Slides',
  zip: 'ZIP',
  fig: 'Figma file',
  md: 'Markdown',
};

export const extOf = (name) => (name.split('.').pop() || '').toLowerCase();

export const kindOf = (name) => KIND_BY_EXT[extOf(name)] ?? (extOf(name).toUpperCase() || 'File');

export const formatSize = (bytes) => {
  if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
};

/**
 * 고른 파일 → 태스크 첨부 모양.
 * 지금은 업로드 대신 브라우저 안의 임시 주소(object URL)를 쓴다 — 새로고침하면 사라진다.
 */
export const toAttachment = (file) => ({
  name: file.name,
  kind: kindOf(file.name),
  size: formatSize(file.size),
  url: URL.createObjectURL(file),
});
